var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.status)?_c('span',{staticClass:"grey--text text--lighten-1"},[_vm._v("-")]):_c('v-chip',{attrs:{"color":_vm.statusConfig.color,"x-small":_vm.xSmall,"small":!_vm.xSmall,"dark":""}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(_vm._s(_vm.statusConfig.icon))]),_vm._v(" "+_vm._s(_vm.statusConfig.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }